import urls from '@constants/urls';

export const buildSpiideoPlayGameUrl = (gameId) => {
    const normalizedGameId = gameId?.trim();
    const baseUrl = urls.services.spiideoPlay;
    const accountId = urls.services.spiideoPlayAccountId;

    if (!normalizedGameId || !baseUrl || !accountId) {
        return null;
    }

    return `${baseUrl}/accounts/${encodeURIComponent(accountId)}/games-list/${encodeURIComponent(normalizedGameId)}`;
};

export const openSpiideoPlayGame = (gameId) => {
    const playUrl = buildSpiideoPlayGameUrl(gameId);

    if (!playUrl) {
        return;
    }

    window.open(playUrl, '_blank', 'noopener,noreferrer');
};
